import * as currency from "@shopify/theme-currency";

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerItem = this.closest(".cart-drawer-item");
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get("cart-remove-button")) {
  customElements.define("cart-remove-button", CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    // Clone object with theme settings from snippets/html-bottom-js.liquid
    this.config = JSON.parse(JSON.stringify(window.cartShippingFee));

    // Find lineItemStatusElement
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value),0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    // Check visitor country
    this.getVisitorCountry().then((country) => {
      const countryCode = country.toLowerCase();
      this.config.countryCode = countryCode;
      this.config.region = 'restOfWorld';
      if (this.config.nearbyEUCountries.countries.includes(countryCode)) {
        this.config.region = 'nearbyEUCountries';
      }
      if (this.config.otherEUCountries.countries.includes(countryCode)) {
        this.config.region = 'otherEUCountries';
      }      
      if (this.config.costomShippinngFee1.countries.includes(countryCode)) {
        this.config.region = 'costomShippinngFee1';
      }      
      if (this.config.costomShippinngFee2.countries.includes(countryCode)) {
        this.config.region = 'costomShippinngFee2';
      }   
      if (this.config.costomShippinngFee3.countries.includes(countryCode)) {
        this.config.region = 'costomShippinngFee3';
      }

      this.calculateShippingFee();
    });
  }

  async getVisitorCountry() {
    const response = await fetch("/browsing_context_suggestions.json");
    const data = await response.json();
    let country = data.detected_values.country.handle;
    return country;
  }

  calculateShippingFee() {

    // Get current subtotal price from cart
    let subtotalPrice = parseInt(document.querySelector("[data-subtotal]").dataset.subtotal);
    let shippingFee = this.config[this.config.region].shippingFee;
    let reducedShippingFee = this.config[this.config.region].reducedShippingFee;
    let reducedShippingThreshold = this.config[this.config.region].reducedShippingThreshold;
    let freeShippingThreshold = this.config[this.config.region].freeShippingThreshold;
    let shippingFeeElement = document.querySelector("[data-cart-shipping-costs]");
    let totalPriceElement = document.querySelector("[data-cart-total-price]");

    // Check if Reduced shipping qualifies
    if (reducedShippingThreshold && subtotalPrice >= reducedShippingThreshold) {
      shippingFee = reducedShippingFee;
    }
    // Check if Free shipping qualifies
    if (freeShippingThreshold && subtotalPrice >= freeShippingThreshold) {
      shippingFee = 0;
    }

    // Sum shipping costs and new subtotal price
    const newTotalPrice = shippingFee + subtotalPrice;

    if (shippingFee == 0) {
      // If shipping costs are 0, render Free label
      shippingFeeElement.innerHTML = this.config.freeLabel.replace(/['"]+/g, "");
    } else {
      // Else show shipping costs in money
      shippingFeeElement.innerHTML = currency.formatMoney(shippingFee, this.config.shopCurrency).replace(/['"]+/g, "");
    }

    // Render new total price
    totalPriceElement.innerHTML = currency.formatMoney(newTotalPrice, this.config.shopCurrency).replace(/['"]+/g, "");
  }

  onChange({ target }) {
    this.updateQuantity(
      target.dataset.index,
      target.valueAsNumber,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-cart-item-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-cart-footer-contents",
      },
      // {
      //   id: "main-cart-footer",
      //   section: document.getElementById("main-cart-footer").dataset.id,
      //   selector: ".cart-drawer__footer",
      // },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "[data-cart-icon-bubble]",
      },
    ];
  }

  async updateQuantity(line, quantity, name) {
    this.enableLoading();
    // console.log('updating quantity');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body },
      });
      const { sections, item_count, items } = await response.json();

      // Toggle classes
      const classToToggle = sections["cart-drawer"]
        ? "cart-drawer-is-empty"
        : "is-empty";
      this.classList.toggle(classToToggle, item_count === 0);
      document
        .getElementById("main-cart-footer")
        ?.classList.toggle("is-empty", item_count === 0);

      // Render the sections
      this.getSectionsToRender().forEach((section) => {
        const { id, selector, section: newSection } = section;
        const elementToReplace =
          document.getElementById(id).querySelector(selector) ||
          document.getElementById(id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          sections[newSection],
          selector
        );
      });

      this.updateLiveRegions(line, item_count);
      document
        .getElementById(`CartItem-${line}`)
        ?.querySelector(`[name="${name}"]`)
        ?.focus();

      // Calculate shipping costs and total price and show on Front End after cart change
      this.calculateShippingFee();

      // Get the item_count multiplied by the item count metafield (for bundled products)
      let itemCountWithBundles = 0;
      items.forEach(
        (item) =>
          (itemCountWithBundles +=
            item.quantity * item.properties._tiered_pricing_count)
      );
      this.handleAllPricesAndBadges(itemCountWithBundles);
    } catch (error) {
      console.error(error);
      document.querySelector(".loading-overlay").classList.add("hidden");
      document.getElementById("cart-errors").textContent =
        window.cartStrings.error;
    } finally {
      this.disableLoading();
    }
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    document.querySelector(".loading-overlay").classList.remove("hidden");
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
    document.querySelector(".loading-overlay").classList.add("hidden");
  }

  handleAllPricesAndBadges(item_count) {
    const tiers = window.tieredPricing.tiers;
    const pricesElements = document.querySelectorAll("tiered-pricing-price");
    const badgesElements = document.querySelectorAll("tiered-pricing-badge");

    // Update the window value
    window.tieredPricing.tiered_pricing_item_count = item_count + 1;

    tiers.forEach(({ tiered_pricing_threshold, tiered_pricing_discount }) => {
      pricesElements.forEach((element) =>
        element.handlePrice(
          false,
          tiered_pricing_threshold,
          tiered_pricing_discount
        )
      );
      badgesElements.forEach((element) =>
        element.handleBadge(
          false,
          tiered_pricing_threshold,
          tiered_pricing_discount
        )
      );
    });
  }
}

if (!customElements.get("cart-items")) {
  customElements.define("cart-items", CartItems);
}
